import Hero from './components/Hero';
import LaserCutting from './components/LaserCutting';
import LaserMarking from './components/LaserMarking';
import Gallery from './components/Gallery';
import ContactInfo from './components/ContactInfo';
import CTA from './components/CTA';

export default function LaserPage() {
  return (
    <main>
      <Hero />
      <LaserCutting />
      <LaserMarking />
      <Gallery />
      <ContactInfo />
      <CTA />
    </main>
  );
}
